import useStore from '../useStore';

const useGameStore = () => {
    const { gameStore } = useStore();

    return gameStore;
};

export default useGameStore;
